export interface GstRateOption {
  label: string
  rate: number
  description?: string
}

export const CONFIGURED_GST_RATES: GstRateOption[] = [
  { label: 'GST @ 18% (Standard Rate)', rate: 18, description: 'Standard rate for most goods & services' },
  { label: 'GST @ 12%', rate: 12, description: 'Standard concessional rate' },
  { label: 'GST @ 5%', rate: 5, description: 'Essential goods & transport' },
  { label: 'GST @ 28%', rate: 28, description: 'Luxury & demerit goods' },
  { label: '0% (Nil / Exempt / Non-GST)', rate: 0, description: 'Exempt or zero-rated expense' },
]

export const calculateGstAmount = (baseAmount: number | string | null | undefined, ratePercent: number | string | null | undefined): number => {
  const base = Number(baseAmount) || 0
  const rate = Number(ratePercent) || 0
  if (base <= 0 || rate <= 0) return 0
  return Math.round(base * (rate / 100) * 100) / 100
}

export const calculateExpenseFinalTotal = (
  baseAmount: number | string | null | undefined,
  taxAmount: number | string | null | undefined
): number => {
  const base = Number(baseAmount) || 0
  const tax = Number(taxAmount) || 0
  return Math.round((base + tax) * 100) / 100
}

export const formatExpenseCurrency = (
  val: number | string | null | undefined,
  currency: string = 'USD'
): string => {
  const num = Number(val) || 0
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency.length === 3 ? currency : 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num)
}

